import React, { useEffect, useState } from 'react';
import { useTranslate } from 'sbx-crm-menu-ui';
import { toast } from 'sonner';
import { readCsvFile, readExcelFile } from 'src/utils';
import TableComponentV2, { KeyHeader } from './TableComponentV2';

type IProps = {
    file: File;
};

const ExcelPreview: React.FC<IProps> = ({ file }) => {
    const [data, setData] = useState<{ [key: string]: string }[]>([]);
    const { t: agent } = useTranslate("agent");

    useEffect(() => {
        handleFileUpload(file);
    }, [file]);

    const handleFileUpload = async(currentFile: File) => {
        if (currentFile) {
            if(currentFile.type.includes('csv')) {
                const dataCsv = await readCsvFile(file);
                if(dataCsv?.length > 0) {
                    setData(dataCsv);
                } else {
                    toast.error(agent("error_excel"));
                }
            } else {
                const dataXlsx = await readExcelFile(file);
                if(dataXlsx?.length > 0) {
                    setData(dataXlsx);
                } else {
                    toast.error(agent("error_excel"));
                }
            }
        }
    };

    return data.length !== 0 ? (
        <TableComponentV2
            items={data}
            header={
                data.length > 0
                    ? Object.keys(data[0]).map((key) => ({
                          key,
                          label: key,
                          type: KeyHeader.KEY,
                      }))
                    : []
            }
            rowClassName="border-b border-gray-200"
            classNameContainer='bg-white bg-opacity-80 backdrop-blur-lg rounded-3xl shadow-2xl p-3'
            tableClassName="w-full"
            classNameTableContainer='max-h-[80vh]'
            actionsClassName="hidden"
            count={data.length}
        />
    ) : (
        <></>
    );
};

export default ExcelPreview;
